export default __webpack_public_path__ + "static/media/sec2-img.f7b638ea.png";